/**
 * Interface for display details used in Summary and Success views
 */
export interface DisplayDetails {
  currency: string;
  network?: string;
  sourceWallet: string;
  sourceWalletName: string;
  amount: number;
  targetWallet: string;
  targetWalletName: string;
  exchangeRate?: number;
  convertedAmount?: number;
  baseCurrencySymbol?: string;
  baseCurrencyPrecision?: number;
  currencyPrecision?: number;
}

/**
 * Extended interface for Success view with optional transaction details
 */
export interface SuccessDisplayDetails extends DisplayDetails {
  transactionId?: string;
  timestamp?: string;
}
